import type { ContentDetail } from "@zzirasi/contracts";
import type { Publication } from "./api";

export function hasUnsavedContent(draft: ContentDetail, persisted: ContentDetail): boolean {
  return draft.title !== persisted.title || draft.body !== persisted.body || draft.caption !== persisted.caption || draft.riskLevel !== persisted.riskLevel;
}

export function anonymizedPreview(detail: Pick<ContentDetail, "title" | "body" | "caption">, from: string, to: string) {
  const replace = (value: string) => from ? value.split(from).join(to) : value;
  return { title: replace(detail.title), body: replace(detail.body), caption: replace(detail.caption) };
}

export function visiblePublications(items: Publication[], scheduled: boolean, focusedId?: string): Publication[] {
  if (focusedId) return items.filter((item) => item.id === focusedId);
  return items.filter((item) => scheduled ? ["READY", "PROCESSING"].includes(item.status) : !["READY", "PROCESSING"].includes(item.status));
}

export function publicationErrorMessage(error: string | null): string | null {
  if (!error) return null;
  if (error === "BROADCAST_BOT_REQUIRED" || /encrypted|cipher/i.test(error)) return "방송 봇 자격 증명을 다시 연결하세요.";
  if (["APPROVAL_STALE", "APPROVAL_HASH_MISMATCH"].includes(error)) return "승인 후 콘텐츠가 변경되었습니다. 다시 검토하고 승인하세요.";
  if (error === "INTERRUPTED_DELIVERY_STATE_UNKNOWN_REAPPROVAL_REQUIRED") return "전송 중 서버가 재시작되어 결과를 확정할 수 없습니다. Telegram을 확인한 뒤 다시 승인하세요.";
  if (error === "INTERRUPTED_AFTER_PARTIAL_DELIVERY_REVIEW_REQUIRED") return "일부 대상에만 전송됐습니다. Telegram 결과를 확인하고 후속 조치하세요.";
  if (/network|timeout/i.test(error)) return "Telegram 연결이 지연됐습니다. 연결 상태를 확인한 뒤 다시 시도하세요.";
  return "Telegram 전송에 실패했습니다. 봇과 게시 대상 권한을 확인하세요.";
}
